export enum CompetitiveChallengeTabType {
  TAB_INFO = "TAB_INFO",
  TAB_TEAM = "TAB_TEAM",
  TAB_RANKING = "TAB_RANKING",
}
